import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Step } from './stepper';
// taro component ini di shared biar reusable

@Component({
  selector: 'stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  imports: [NgClass, TranslatePipe],
  standalone: true
})
export class StepperComponent {
  default = input<boolean>();
  steps = input<Step[]>([]);
}
